export default function (...args)
{
	return {
		regex: /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
		filter: /[-.]/g,
		store_mask: '$1$2$3$4',
		display_mask: '$1.$2.$3-$4'
	};
}

